import { Link, Route, BrowserRouter as Router,Routes} from "react-router-dom"
import './App.css';
import Contactanos from './components/pages/contactanos';
import Home from "./components/pages/inicio";
import ExperienciaLaboral from './components/pages/experienciaLaboral/index';
import Prueba from "./components/pages/pruebas";
import NotFound from "./components/pages/notFound";
import GitProject from "./components/pages/gitProjects";
import { useEffect, useState } from "react";
import GitHubProjectsContextProvider from "./components/ContextProvider";


function App() {
  
  const [reposData, setReposData] = useState([]);
  useEffect(() => {
    // Obtener los repositorios del usuario de GitHub
    fetch("https://api.github.com/users/YanethCundarM/repos")
      .then((response) => response.json())
      .then((repos) => {
        // Mapear los datos necesarios de cada repositorio
        const reposInfo = repos.map((repo) => ({
          name: repo.name,
          created_at: repo.created_at,
          language: repo.language
        }));
        // Actualizar el estado con la información mapeada
        setReposData(reposInfo);
      })
      .catch((error) => {
        console.error("Error al obtener los repositorios:", error);
      });
  }, []);

  return (
  <GitHubProjectsContextProvider initialValue={reposData}>
  <div className= "App">
    <div className="App">
      <div className="contenido">
        <div className="imagen"> 
        </div>
          <div>
          <Router>
          <div>
            <nav>
              <ul>
                <div className="enlaces">
                    <div>
                      <li className="enlaces"><Link to="/">Inicio</Link></li>
                    </div>
                    <div>
                      <li><Link to="/contactanos">Contactanos</Link></li>
                    </div>
                    <div>
                      <li><Link to ="/experienciaLaboral">Experiencia Laboral</Link></li>
                    </div>
                    <div>
                      <li><Link to ="/notFound">Not Found</Link></li>
                    </div>
                    <div>
                      <li><Link to ="/pruebas">Prueba</Link></li>
                    </div>
                    <div>
                      <li><Link to ="/gitProjects">Git Projects</Link></li>
                    </div>
                </div>
                
              </ul>
            </nav>
          </div>
          <div>
          </div>        
          <Routes>
              <Route path="/"element={<Home/>} /> 
              <Route path="/contactanos"element={<Contactanos/>} />
              <Route path="/experienciaLaboral" element= {<ExperienciaLaboral/>} />
              <Route path="/pruebas" element= {<Prueba/>} />
              <Route path="/notfound" element= {<NotFound/>} />
              <Route path="/gitProjects" element= {<GitProject/>} />
          </Routes>
          </Router>
      </div>
    </div> 
   </div>
   </div>
   </GitHubProjectsContextProvider>
  )
}
export default App